module.exports = __webpack_public_path__ + "img/enugu.c778b257.svg";